var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{class:[_vm.$style['icon'], 'ueicon-' + _vm.name]})
}
var staticRenderFns = []

export { render, staticRenderFns }